// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ChooseLayout_wrapper__2pqA1","squares":"ChooseLayout_squares__2dkQo","select":"ChooseLayout_select__1IB-e"};